export default {
    firstLevelName({commit}, value) {
        commit("setFirstLevelName", value)
    },
    fetchDealerReviews({commit}, value) {
        commit("setSecondLevelName", value)
    },
};
